define('SuiteCommerce.OrderStatus.OrderFinder.Help.View',
  [
    'suitecommerce_orderstatus_search_form_help.tpl',
    'SuiteCommerce.OrderStatus.Utils',
    'Backbone'
  ],
  function define(
    Template,
    Utils,
    Backbone
  ) {
    'use strict';
    return Backbone.View.extend({
      template: Template,
      initialize : function initialize(){
        this.title = Utils.getConfigurationParameter('helpLink');
      },
      getContext: function getContext() {
        return {
          body: Utils.getConfigurationParameter('helpText')
        };
      }
    });
  });
